import { nsSig } from '../img/ns-sig'

export const formS1585 = (): any[] => [
  {
    text: 'Thank you for your recent request regarding the personal information that SAFE Credit Union (SAFE) may have collected about you when you were applying for a financial product or service or while maintaining your account with us.',
    marginBottom: 10
  },
  {
    text: 'As a financial institution, SAFE, for many years prior to the enactment of the California Consumer Privacy Act, has been subject to, and remains subject to, strict and comprehensive federal and state consumer information privacy laws, such as the federal Gramm-Leach-Bliley Act and the California Financial Information Privacy Act.  Under these laws, SAFE discloses the ways we collect, retain, share, and use personal information to provide financial products and services, to maintain accounts, for legal reasons, and to preserve the security of accounts. We do not sell consumers’ personal information.',
    marginBottom: 10
  },
  {
    text: 'Because of the nature of our business and the consumer information privacy laws that we adhere to, the personal information SAFE obtained from you when you were applying for a financial product or service or maintaining an account with us is  exempt from requests to restrict sharing, know, or delete the personal information we have collected.',
    marginBottom: 10
  },
  {
    text: [
      { text: 'Rest assured, SAFE is committed to maintaining strong privacy programs that adhere to strict data privacy and security requirements. To learn more, please visit ' },
      { text: 'safecu.org/privacy. ', bold: true },
    ],
    marginBottom: 10
  },
  {
    text: 'If you have any questions, please feel free to contact a helpful SAFE representative at'
  },
  {
    text: [
      { text: '(916) 979-7233 ', bold: true },
      { text: 'or ' },
      { text: '(800) SEE-SAFE.', bold: true }
    ],
    marginBottom: 10
  },
  { text: 'Sincerely,', marginBottom: 5, marginTop: 10 },
  { image: nsSig, width: 140, marginBottom: 5 },
  { text: 'Nicole Smith' },
  { text: 'VP, Contact Center' },
  { text: 'SAFE Credit Union' }
]
